import React, { useState, useEffect } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { getSettings, saveSettings, clientsApi } from '../services/api';

export default function Settings() {
  const [baseUrl, setBaseUrl] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [saved, setSaved] = useState(false);
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  useEffect(() => {
    const s = getSettings();
    setBaseUrl(s.baseUrl);
    setApiKey(s.apiKey);
  }, []);

  function handleSave(e) {
    e.preventDefault();
    saveSettings({ baseUrl: baseUrl.trim().replace(/\/$/, ''), apiKey: apiKey.trim() });
    setSaved(true);
    setTestResult(null);
    setTimeout(() => setSaved(false), 2500);
  }

  async function handleTest() {
    setTesting(true);
    setTestResult(null);
    try {
      await clientsApi.getAll();
      setTestResult({ ok: true, msg: 'Connection successful.' });
    } catch (err) {
      setTestResult({ ok: false, msg: err.message });
    } finally {
      setTesting(false);
    }
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Settings</h1>
        <p className="page-subtitle">Configure the connection to your SeikoAuth server</p>
      </div>

      <div className="settings-card">
        <form onSubmit={handleSave}>
          <FormGroup>
            <Label className="form-label-custom">API Base URL</Label>
            <Input
              value={baseUrl}
              onChange={(e) => setBaseUrl(e.target.value)}
              placeholder="http://localhost:5000"
              type="url"
            />
            <small style={{ color: '#8892a4', fontSize: 12 }}>
              The root URL of your SeikoAuth server (no trailing slash)
            </small>
          </FormGroup>

          <FormGroup>
            <Label className="form-label-custom">Admin API Key</Label>
            <Input
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
              type="password"
            />
            <small style={{ color: '#8892a4', fontSize: 12 }}>
              Sent as the <code>X-Admin-Key</code> header on every request
            </small>
          </FormGroup>

          <div className="d-flex align-items-center" style={{ gap: 10 }}>
            <Button className="btn-primary" type="submit">
              Save Settings
            </Button>
            <Button
              color="secondary"
              type="button"
              onClick={handleTest}
              disabled={testing}
              style={{ borderRadius: 8 }}
            >
              {testing ? 'Testing...' : 'Test Connection'}
            </Button>
            {saved && (
              <span style={{ color: '#065f46', fontSize: 13, fontWeight: 600 }}>
                Saved
              </span>
            )}
          </div>
        </form>

        {testResult && (
          <div
            className="mt-3"
            style={{
              padding: '10px 14px',
              borderRadius: 8,
              fontSize: 13,
              background: testResult.ok ? '#d1fae5' : '#fee2e2',
              color: testResult.ok ? '#065f46' : '#991b1b',
              border: `1px solid ${testResult.ok ? '#a7f3d0' : '#fca5a5'}`,
            }}
          >
            {testResult.ok ? '✓' : '✗'} {testResult.msg}
          </div>
        )}

        <hr style={{ margin: '24px 0', borderColor: '#e8ecf3' }} />

        <div>
          <p className="form-label-custom" style={{ marginBottom: 8 }}>Stored settings</p>
          <p style={{ fontSize: 13, color: '#5b6b8a', margin: 0 }}>
            Settings are saved in your browser's localStorage and never sent to any server
            other than the configured SeikoAuth endpoint.
          </p>
        </div>
      </div>
    </div>
  );
}
